// Tipos compartilhados entre frontend e backend
export * from './multi-tenancy';
export * from './linkedin';
export * from './reports';
export * from './pipeline';
// ============================================
// ENUMS
// ============================================
export var JobStatus;
(function (JobStatus) {
    JobStatus["DRAFT"] = "draft";
    JobStatus["OPEN"] = "open";
    JobStatus["PAUSED"] = "paused";
    JobStatus["CLOSED"] = "closed";
})(JobStatus || (JobStatus = {}));
export var CandidateStatus;
(function (CandidateStatus) {
    CandidateStatus["PENDING"] = "pending";
    CandidateStatus["ANALYZING"] = "analyzing";
    CandidateStatus["APPROVED"] = "approved";
    CandidateStatus["REJECTED"] = "rejected";
    CandidateStatus["INTERVIEWED"] = "interviewed";
    CandidateStatus["HIRED"] = "hired";
})(CandidateStatus || (CandidateStatus = {}));
export var InterviewStatus;
(function (InterviewStatus) {
    InterviewStatus["PENDING"] = "pending";
    InterviewStatus["TRANSCRIBING"] = "transcribing";
    InterviewStatus["SCORING"] = "scoring";
    InterviewStatus["DONE"] = "done";
})(InterviewStatus || (InterviewStatus = {}));
export var QuestionCategory;
(function (QuestionCategory) {
    QuestionCategory["TECHNICAL"] = "technical";
    QuestionCategory["BEHAVIORAL"] = "behavioral";
    QuestionCategory["SITUATIONAL"] = "situational";
    QuestionCategory["CULTURE"] = "culture";
})(QuestionCategory || (QuestionCategory = {}));
export var OrganizationPlan;
(function (OrganizationPlan) {
    OrganizationPlan["FREE"] = "free";
    OrganizationPlan["PRO"] = "pro";
    OrganizationPlan["ENTERPRISE"] = "enterprise";
})(OrganizationPlan || (OrganizationPlan = {}));
// ============================================
// CONSTANTS
// ============================================
export const APPROVAL_THRESHOLD = 70;
export const MAX_FILE_SIZE = 10 * 1024 * 1024; // 10MB
export const MAX_AUDIO_SIZE = 500 * 1024 * 1024; // 500MB
export const PRESIGNED_URL_EXPIRATION = 15 * 60; // 15 minutes
export const MAX_BATCH_SIZE = 20;
export const ALLOWED_FILE_TYPES = [
    'application/pdf',
    'application/msword',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
];
export const VALID_STATUS_TRANSITIONS = {
    [CandidateStatus.PENDING]: [CandidateStatus.APPROVED, CandidateStatus.REJECTED],
    [CandidateStatus.ANALYZING]: [],
    [CandidateStatus.APPROVED]: [CandidateStatus.REJECTED, CandidateStatus.INTERVIEWED, CandidateStatus.HIRED],
    [CandidateStatus.REJECTED]: [CandidateStatus.APPROVED],
    [CandidateStatus.INTERVIEWED]: [CandidateStatus.HIRED, CandidateStatus.REJECTED],
    [CandidateStatus.HIRED]: [],
};
// ============================================
// INTERVIEW CONSTANTS
// ============================================
export const AUDIO_FORMATS = {
    'audio/mpeg': 'mp3',
    'audio/mp3': 'mp3',
    'audio/wav': 'wav',
    'audio/x-wav': 'wav',
    'audio/mp4': 'mp4',
    'audio/x-m4a': 'mp4',
    'audio/ogg': 'ogg',
};
export const INTERVIEW_ERRORS = {
    CANDIDATE_NOT_APPROVED: 'CANDIDATE_NOT_APPROVED',
    INTERVIEW_NOT_FOUND: 'INTERVIEW_NOT_FOUND',
    INVALID_AUDIO_FORMAT: 'INVALID_AUDIO_FORMAT',
    AUDIO_TOO_LARGE: 'AUDIO_TOO_LARGE',
    TRANSCRIPTION_FAILED: 'TRANSCRIPTION_FAILED',
    SCORING_FAILED: 'SCORING_FAILED',
    INVALID_SCORING_RESPONSE: 'INVALID_SCORING_RESPONSE',
    EMPTY_TRANSCRIPT: 'EMPTY_TRANSCRIPT',
    UNAUTHORIZED: 'UNAUTHORIZED',
    FORBIDDEN: 'FORBIDDEN',
    INTERVIEW_NOT_SCORED: 'INTERVIEW_NOT_SCORED',
    REVIEW_LIMIT_REACHED: 'REVIEW_LIMIT_REACHED',
    REVIEW_SESSION_NOT_FOUND: 'REVIEW_SESSION_NOT_FOUND',
    REVIEW_MESSAGE_TOO_SHORT: 'REVIEW_MESSAGE_TOO_SHORT',
    REVIEW_TURNS_EXCEEDED: 'REVIEW_TURNS_EXCEEDED',
    REVIEW_IN_PROGRESS: 'REVIEW_IN_PROGRESS',
    REVIEW_GENERATION_FAILED: 'REVIEW_GENERATION_FAILED',
};
// ============================================
// REVIEW CONSTANTS
// ============================================
export const MAX_REVIEW_COUNT = 3;
export const MIN_REVIEW_MESSAGE_LENGTH = 10;
export const MAX_REVIEW_TURNS = 3;
// Assistant Constants
export const ASSISTANT_MAX_TOOL_CALLS = 5;
export const ASSISTANT_MAX_HISTORY_MESSAGES = 20;
export const ASSISTANT_MAX_TOOL_RESULTS = 50;
export const ASSISTANT_SESSION_TIMEOUT_MS = 30 * 60 * 1000; // 30 minutes
export const ASSISTANT_PROCESSING_TIMEOUT_MS = 25 * 1000; // 25 seconds
